//  ##  ##     ##              ###    ##     ##  ##  ###    ###  #####
//  ##  ####   ##             ## ##   ####   ##  ##  ## #  # ##  ##
//  ##  ##  ## ##  ########  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
//  ##  ##    ###            #######  ##    ###  ##  ##      ##  ##
//  ##  ##     ##            ##   ##  ##     ##  ##  ##      ##  #####
/*
画面に入った監視対象に.animatedを付加
animatedによってアニメーションするクラスは_anime.scssとそのスタイルガイドを参照
*/
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.querySelectorAll('.js-in:not(.animated)')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
window.intObs() // 画面交差API起動
